<template>
    <div id="RekeningKorespondensi">
        <div class="row mb-4">
            <div class="col-sm-8">
                <h2>Manajemen Rekening Bank</h2>
            </div>
            <div class="col-sm-4 text-right">
                <b-link to="/add-bank" class="mr-2" v-if="user.id != user.mitra_id">
                    <b-button variant="primary" class="btn btn-custom theme-color px-4">Tambah Rekening</b-button>
                </b-link>
                <!-- <b-link to="/download-banks">
                    <b-button variant="primary" class="btn btn-custom theme-color text-white px-4 rounded-0">Download</b-button>
                </b-link> -->
            </div>
        </div>

        <div class="row no-gutters mb-4">
            <div class="col-md-9">
                <label>Filter Berdasarkan Tanggal :</label>
                <div class="form-inline">
                    <input name="start_date" type="text" onfocus="(this.type='date')" placeholder="Mulai Dari"
                        class="form-control mr-2">
                    <input name="end_date" type="text" onfocus="(this.type='date')" placeholder="Sampai Dengan"
                        class="form-control mr-2">
                    <b-button class="btn btn-custom btn-sm" @click="applyDateFilter">Filter</b-button>
                </div>
            </div>
        </div>
        <div class="row no-gutters mb-4">
            <div class="col-md-9">
                <div class="form-inline">
                <b-form-input v-model="filter" type="search" placeholder="Ketik untuk mencari .."></b-form-input>
                <b-button :disabled="!filter" @click="resetFilter"
                    class="btn btn-custom theme-color ml-2">Reset</b-button>
                </div>
            </div>
        </div>

        <div class="overflow-auto">
            <b-table id="bank-table" responsive :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
                <!-- Menambahkan Indeks Berurutan -->
                <template v-slot:cell(id_rekening)="data">
                    {{ (currentPage - 1) * perPage + data.index + 1 }}
                </template>
                <!-- <template v-slot:cell(is_active)="data">
                    <b-icon :icon="data.item.is_active ? 'toggle-on' : 'toggle-off'" scale="2" :variant="data.item.is_active ? 'success' : 'danger'" @click="changeStatus(data.item.id)"></b-icon>
                </template> -->
                <template v-slot:cell(aksi)="data" v-if="user.id != user.mitra_id">
                    <b-link :to="{ name: 'EditBank', params: { id: data.item.id } }">
                        <b-icon icon="pencil" scale="2" class="mx-2" variant="primary"></b-icon>
                    </b-link>
                    <b-link @click="confirmDeleteBank(data.item.id)">
                        <b-icon icon="trash" scale="2" class="mx-2" variant="danger"></b-icon>
                    </b-link>
                </template>
            </b-table>

            <b-spinner v-if="!loaded" variant="warning" class="d-block mx-auto"></b-spinner>
            <b-pagination v-if="loaded" align="center" :total-rows="rows" :per-page="perPage" aria-controls="bank-table" v-model="currentPage" hide-goto-end-buttons></b-pagination>
        </div>

        <b-modal size="sm" v-model="confirmDeleteModal" hide-footer hide-header>
            <div class="d-block text-center">
                <h3>Anda yakin ingin menghapus rekening ini?</h3>
                <div class="row mt-4">
                    <div class="col">
                        <b-button block @click="deleteBank">Ya</b-button>
                    </div>
                    <div class="col">
                        <b-button block @click="cancelDeleteBank">Tidak</b-button>
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal size="sm" v-model="successDeleteModal" hide-footer hide-header>
            <div class="d-block text-center">
                <b-icon icon="exclamation-circle" class="mb-2" style="width: 120px; height: 120px;"></b-icon>
                <h3>Rekening berhasil dihapus</h3>
                <b-button class="mt-3" block @click="successDeleteModal = false">Tutup</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import user from "../../api/user";
import UserBank from "../../api/userbank";

export default {
    data() {
        return {
            items: [],
            fields: [
                { key: 'id_rekening', label: 'No.' },
                { key: 'bank.name', label: 'Nama Bank' },
                { key: 'account_number', label: 'Nomor Rekening' },
                { key: 'account_name', label: 'Nama Pemilik' },
                // { key: 'is_active', label: 'Status Aktif' },
                { key: 'aksi', label: 'Aksi' }
            ],
            perPage: 10,
            currentPage: 1,
            filter: '',
            sortBy: '',
            sortDesc: false,
            confirmDeleteModal: false,
            successDeleteModal: false,
            deleteBankId: null,
            loaded: false,
            user: null,
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        rows() {
            return this.items.length;
        }
    },
    mounted() {
        this.loadBanks();
    },
    methods: {
        loadBanks() {
            let profile = this.currentUser.info;
            this.user = profile;

            // Dynamically filter fields
            this.fields = this.fields.filter((field) => {
                if (field.key === 'aksi' && this.user.id == this.user.mitra_id) {
                    return false; // Remove 'aksi' if condition is met
                }
                return true; // Keep other fields
            });

            UserBank.index()
                .then((res) => {
                    this.items = res.data.data.data;
                    this.loaded = true;
                    // console.log('data bank', res.data.data.data);
                })
                .catch((err) => console.error('Error loading banks:', err));
        },
        applyDateFilter() {
            // Implementasi logika untuk filter berdasarkan tanggal
        },
        resetFilter() {
            this.filter = '';
        },
        confirmDeleteBank(id) {
            this.deleteBankId = id;
            this.confirmDeleteModal = true;
        },
        deleteBank() {
            UserBank.delete(this.deleteBankId)
                .then((res) => {
                    if (res.data.meta.code === 200) {
                        this.successDeleteModal = true;
                        this.loadBanks();
                    }
                })
                .catch((err) => console.error('Error deleting bank:', err));
            this.confirmDeleteModal = false;
        },
        cancelDeleteBank() {
            this.confirmDeleteModal = false;
            this.deleteBankId = null;
        }
    }
};
</script>

<style>
#ManajemenRekeningBank {
    margin: 20px;
}

.b-table thead th {
    text-align: center;
}

.b-table tbody td {
    text-align: center;
}
.btn-custom {
  background-color: #f6bc3c;
  color: #274c8f;
  border-radius: 5px;
}
.btn-custom:hover {
  background-color: #274c8f;
  color: #ffffff;
}
.cancel:hover {
  background-color: #fd0000;
  color: #ffffff;
}
.success:hover {
  background-color: #00b300;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/rekening-korespondensi.vue